import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emptyColumnHeader: {
		id: 'polaris-ideas.view-content.idea-board-next.column-header.numbers.empty-column-header.non-final',
		defaultMessage: 'No field value',
		description: 'Header for the "empty" number value columns',
	},
});
